import React, {useCallback, useMemo} from "react";
import BasicUserDashboard from "../dashboard/BasicUserDashboard";
import {toaster} from "rsuite";
import UserAckModal from "../modals/UserAckModal";
import {getUserInformation, updateUserAck} from "../../service/userService";
import SuccessNotification from "../notifications/SuccessNotification";
import {USER_ACK_UPDATE_ERROR, USER_ACK_UPDATE_SUCCESS} from "../../service/constants";
import {setUserInfo} from "../../redux/userSlice";
import ErrorNotification from "../notifications/ErrorNotification";
import {useDispatch, useSelector} from "react-redux";

const ACK_MSG_BLURB = " By using this system you acknowledge that all data entered is unclassified and you have " +
    "gone through the correct channels for pre-publication, etc...";

const Dashboard = () => {
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.user.userInfo );

    const submitUserAck = useCallback(() => {
        const userWithAck = {...userInfo, ack: true};
        updateUserAck(userWithAck).then(({result}) => {
            if (result === 'success') {
                getUserInformation(userInfo.email).then((userInfo) => {
                    toaster.push(<SuccessNotification message={USER_ACK_UPDATE_SUCCESS} />, { placement: 'topCenter' });
                    dispatch(setUserInfo(userInfo));
                })
            } else {
                toaster.push(<ErrorNotification message={USER_ACK_UPDATE_ERROR} />, { placement: 'topCenter' });
            }
        });
    }, [dispatch, userInfo]);

    return useMemo(() => {
        return (
            <>
                <div className="main-content">
                    <h2>Welcome, {userInfo?.firstName} {userInfo?.lastName}</h2>
                    <BasicUserDashboard />
                </div>
                {
                    userInfo?.ack ?
                        null
                        :
                        <UserAckModal
                            handleClose={submitUserAck}
                            open={userInfo?.ack === false}
                            systemMessageBlurb={ACK_MSG_BLURB}
                        />
                }
            </>
        );
    }, [submitUserAck, userInfo]);
}

export default Dashboard;